import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 34 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div className={className} initial={reduce ? false : { opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-8% 0px -8% 0px" }} transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", id }) => (
  <Reveal className={align === "center" ? "mx-auto max-w-4xl text-center" : "max-w-4xl"}>
    {eyebrow && <p className="eyebrow" data-testid={id ? `${id}-eyebrow` : undefined}>{eyebrow}</p>}
    <h2 className="display-title mt-5 text-4xl leading-[1.03] text-[#f1f3ec] sm:text-5xl lg:text-7xl">{title}</h2>
    {subtitle && <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/55 md:text-lg">{subtitle}</p>}
  </Reveal>
);
